import React from 'react';
import { View } from 'react-native';

import { useProviderEnrollments } from '@/hooks/use-enrollments';
import { useOperationalMetrics } from '@/hooks/use-provider';
import { useTerms } from '@/hooks/use-terms';
import { ENROLLMENT_STATUS } from '@/types/enrollment-status';
import { formatCurrency } from '@/utils/format-currency';
import { SummaryEmpty, SummaryRow, SummarySkeleton, SummaryStat } from '../home-summary-dialog';

/** Prévia de Contratos: quantos estão ativos e os últimos criados. */
export function EnrollmentsSummary() {
  const { data: metrics } = useOperationalMetrics();
  const { data: paginated, isLoading } = useProviderEnrollments({ page: 1, limit: 5 });
  const terms = useTerms();

  const enrollments = paginated?.data ?? [];
  const monthlyTotal = enrollments
    .filter((enrollment) => enrollment.status === ENROLLMENT_STATUS.ACTIVE)
    .reduce((sum, enrollment) => sum + (enrollment.price ?? 0), 0);

  return (
    <View className="gap-3">
      <View className="flex-row gap-2">
        <SummaryStat
          label={`${terms.title.enrollmentPlural} ${terms.agree('ativos', 'enrollment')}`}
          value={`${metrics?.activeEnrollments ?? 0}`}
        />
        <SummaryStat label="Valor dos ativos" value={formatCurrency(monthlyTotal)} />
      </View>

      {isLoading ? (
        <SummarySkeleton rows={3} />
      ) : enrollments.length ? (
        <View className="gap-2">
          {enrollments.slice(0, 4).map((enrollment) => (
            <SummaryRow
              key={enrollment.id}
              icon="document-text-outline"
              title={enrollment.client?.user?.username || terms.title.client}
              description={enrollment.service?.name ?? terms.title.service}
              value={formatCurrency(enrollment.price ?? 0)}
            />
          ))}
        </View>
      ) : (
        <SummaryEmpty
          message={`${terms.agree('Nenhum', 'enrollment')} ${terms.enrollment} ${terms.agree(
            'cadastrado',
            'enrollment',
          )}.`}
        />
      )}
    </View>
  );
}
